import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export const UniqueIdValidator = (forms: FormArray, controlName: string): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    let valueExists = false;

    if (activeControl.value && forms.controls.length > 1) {
      forms.controls
        .filter(form => form.get(controlName) !== activeControl)
        .forEach(form => {
          const compareControl = form.get(controlName);
          if (
            compareControl &&
            compareControl.value &&
            compareControl.value === activeControl.value
          ) {
            valueExists = true;
            activeControl.markAsTouched();
          }
        });
    }

    return valueExists ? { uniqueRequired: activeControl.value } : null;
  };
};
